var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4", attrs: { "data-id": _vm.id } },
    [
      _c(
        "div",
        {
          staticClass: "sticky top-0 z-10 bg-pure-white",
          attrs: { "data-id": _vm.id }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-3 px-6 py-5",
              attrs: { "data-id": _vm.id }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex flex-col gap-2",
                  attrs: { "data-id": _vm.id }
                },
                [
                  _vm.appointment.client && _vm.appointment.client.name
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between gap-4",
                          attrs: {
                            "data-id": _vm.id,
                            title:
                              "Appointment for " + _vm.appointment.client.name
                          }
                        },
                        [
                          _c("BlTextSubtitle1", {
                            staticClass: "truncate",
                            attrs: {
                              "data-id": _vm.id,
                              text:
                                "Appointment for " + _vm.appointment.client.name
                            }
                          }),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass: "w-6 h-6",
                            attrs: {
                              icon: "close",
                              color: "slate-6",
                              clickable: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.appointment.client && _vm.appointment.client.name
                    ? _c("BlTextBody2", {
                        staticClass: "truncate",
                        attrs: {
                          "data-id": _vm.id,
                          title:
                            "You're viewing an appointment for " +
                            _vm.appointment.client.name +
                            ".",
                          text:
                            "You're viewing an appointment for " +
                            _vm.appointment.client.name +
                            "."
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("SlotDetails", {
                attrs: {
                  "data-id": _vm.id,
                  id: _vm.id,
                  appointment: _vm.appointment,
                  asHeader: "",
                  useAction: ""
                },
                on: {
                  "open-cancellation": function($event) {
                    _vm.cancelOpened = true
                  },
                  "open-reschedule": function($event) {
                    _vm.rescheduleOpened = true
                  },
                  "after-commit": function($event) {
                    return _vm.$emit("after-commit")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "flex-shrink-0 w-full h-5 bg-slate-200",
            attrs: { "data-id": _vm.id }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col px-6", attrs: { "data-id": _vm.id } },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-1 mb-1",
              attrs: { "data-id": _vm.id }
            },
            [
              _c("BlTextSubtitle2", {
                attrs: {
                  "data-id": _vm.id,
                  text: "All upcoming scheduled appointments for this client"
                }
              }),
              _vm._v(" "),
              _vm.appointment.client && _vm.appointment.client.name
                ? _c("BlTextBody2", {
                    staticClass: "truncate",
                    attrs: {
                      "data-id": _vm.id,
                      text:
                        _vm.appointment.upcoming_appointments.length +
                        " scheduled appointment(s) for " +
                        _vm.appointment.client.name +
                        "."
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.appointment.upcoming_appointments, function(item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "flex flex-col gap-4 mb-4",
                attrs: { "data-id": _vm.id }
              },
              [
                _c("SlotDetails", {
                  attrs: {
                    "data-id": _vm.id,
                    id: _vm.id,
                    appointment: item,
                    useAction: ""
                  },
                  on: {
                    "open-cancellation": function($event) {
                      _vm.cancelOpened = true
                    },
                    "open-reschedule": function($event) {
                      _vm.rescheduleOpened = true
                    },
                    "after-commit": function($event) {
                      return _vm.$emit("after-commit")
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "h-0.5 w-full flex-shrink-0 bg-slate-300",
                  attrs: { "data-id": _vm.id }
                })
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.cancelOpened && _vm.currentUser.role.includes("admin")
        ? _c("CancelAppointmentModal", {
            attrs: { appointmentId: _vm.appointment.id },
            on: {
              "close-modal": function($event) {
                _vm.cancelOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.rescheduleOpened && _vm.currentUser.role.includes("admin")
        ? _c("RescheduleAppointmentOverlay", {
            attrs: { appointmentId: _vm.appointment.id },
            on: {
              "close-modal": function($event) {
                _vm.rescheduleOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffa13a6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffa13a6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/timeslot/UpcomingAppointments.vue
// module id = null
// module chunks = 